<style scoped="scoped" lang="scss"></style>
<style>
.el-select .el-input {
  width: 90px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/document/type/configuration/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('danjuleixing')" required>
            <el-select v-model="yt.conditions.type" clearable>
              <el-option :label="$t('ruku')" :value="'0'"></el-option>
              <el-option :label="$t('chuku')" :value="'1'"></el-option>
              <el-option :label="$t('kunei')" :value="'2'"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('danjudalei')" required>
            <yi_dictionary_select :key="0" v-if="yt.conditions.type == 0" :max="1" :type="'DOCUMENT_TYPE_CONFIGURATION_WAREHOUSING_TYPE'" :ids.sync="yt.conditions.categories"> </yi_dictionary_select>
            <yi_dictionary_select :key="1" v-else-if="yt.conditions.type == 1" :max="1" :type="'DOCUMENT_TYPE_CONFIGURATION_OUTBOUND_TYPE'" :ids.sync="yt.conditions.categories"> </yi_dictionary_select>
            <yi_dictionary_select :key="2" v-else-if="yt.conditions.type == 2" :max="1" :type="'DOCUMENT_TYPE_CONFIGURATION_INSIDE_TYPE'" :ids.sync="yt.conditions.categories"> </yi_dictionary_select>
            <yi_dictionary_select :key="3" v-else :max="0" :type="''"> </yi_dictionary_select>
          </el-form-item>

          <el-form-item :label="$t('danjuxiaoleibianma')" required>
            <el-input v-model="yt.conditions.smallCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('danjuxiaoleimingcheng')" required>
            <el-input v-model="yt.conditions.smallName"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t("sousuo") }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t("chongzhi") }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" v-if="utils.checkPower('web_system_auth_user_create')" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary">
          {{ $t("xinzeng") }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>

      <template #danjuleixing="scope">
        <template>
          <span v-if="scope.row.type == 0">{{ $t("ruku") }}</span>
          <span v-if="scope.row.type == 1">{{ $t("chuku") }}</span>
          <span v-if="scope.row.type == 2">{{ $t("kunei") }}</span>
        </template>
      </template>
      <template #danjudalei="scope">
        <template>
          <span v-if="scope.row.type == 0">{{ $t(store.state.dictJsonAll["DOCUMENT_TYPE_CONFIGURATION_WAREHOUSING_TYPE"][scope.row.categories]) }}</span>
          <span v-if="scope.row.type == 1">{{ $t(store.state.dictJsonAll["DOCUMENT_TYPE_CONFIGURATION_OUTBOUND_TYPE"][scope.row.categories]) }}</span>
          <span v-if="scope.row.type == 2">{{ $t(store.state.dictJsonAll["DOCUMENT_TYPE_CONFIGURATION_INSIDE_TYPE"][scope.row.categories]) }}</span>
        </template>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_system_auth_user_update')" @click="yt.showEditDialog('bianji', scope.row)">{{ $t("bianji") }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/document/type/configuration/delete')">{{ $t("shanchu") }} </el-button>
          </el-col>
        </el-row>
      </template>
      <!-- 底部插槽 -->
      <!-- <div slot="footer"></div> -->
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('danjuleixing')" required>
            <el-select v-model="yt.editObj.type">
              <el-option :label="$t('ruku')" :value="'0'"></el-option>
              <el-option :label="$t('chuku')" :value="'1'"></el-option>
              <el-option :label="$t('kunei')" :value="'2'"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('danjudalei')" required>
            <yi_dictionary_select :key="0" v-if="yt.editObj.type == 0" :max="1" :type="'DOCUMENT_TYPE_CONFIGURATION_WAREHOUSING_TYPE'" :ids.sync="yt.editObj.categories"> </yi_dictionary_select>
            <yi_dictionary_select :key="1" v-else-if="yt.editObj.type == 1" :max="1" :type="'DOCUMENT_TYPE_CONFIGURATION_OUTBOUND_TYPE'" :ids.sync="yt.editObj.categories"> </yi_dictionary_select>
            <yi_dictionary_select :key="2" v-else-if="yt.editObj.type == 2" :max="1" :type="'DOCUMENT_TYPE_CONFIGURATION_INSIDE_TYPE'" :ids.sync="yt.editObj.categories"> </yi_dictionary_select>
            <yi_dictionary_select :key="3" v-else :max="0" :type="''"> </yi_dictionary_select>
          </el-form-item>

          <el-form-item :label="$t('danjuxiaoleibianma')" required>
            <el-input v-model="yt.editObj.smallCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('danjuxiaoleimingcheng')" required>
            <el-input v-model="yt.editObj.smallName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.enable">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/document/type/configuration/create')" type="primary">
            {{ $t("baocun") }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('danjuleixing')" required>
            <el-select v-model="yt.editObj.type">
              <el-option :label="$t('ruku')" :value="'0'"></el-option>
              <el-option :label="$t('chuku')" :value="'1'"></el-option>
              <el-option :label="$t('kunei')" :value="'2'"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('danjudalei')" required>
            <yi_dictionary_select :key="0" v-if="yt.editObj.type == 0" :max="1" :type="'DOCUMENT_TYPE_CONFIGURATION_WAREHOUSING_TYPE'" :ids.sync="yt.editObj.categories"> </yi_dictionary_select>
            <yi_dictionary_select :key="1" v-else-if="yt.editObj.type == 1" :max="1" :type="'DOCUMENT_TYPE_CONFIGURATION_OUTBOUND_TYPE'" :ids.sync="yt.editObj.categories"> </yi_dictionary_select>
            <yi_dictionary_select :key="2" v-else-if="yt.editObj.type == 2" :max="1" :type="'DOCUMENT_TYPE_CONFIGURATION_INSIDE_TYPE'" :ids.sync="yt.editObj.categories"> </yi_dictionary_select>
            <yi_dictionary_select :key="3" v-else :max="0" :type="''"> </yi_dictionary_select>
          </el-form-item>

          <el-form-item :label="$t('danjuxiaoleibianma')" required>
            {{ yt.editObj.smallCode }}
          </el-form-item>
          <el-form-item :label="$t('danjuxiaoleimingcheng')" required>
            <el-input v-model="yt.editObj.smallName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.enable">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/document/type/configuration/update')" type="primary">{{ $t("baocun") }} </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_system_document_type_list",
  components: {},
  data() {
    return {
      show: false,
      list: [],
      rolesList: [],
      columns: [
        {
          label: "danjuleixing",
          prop: "type",
          type: "slot",
        },
        {
          label: "danjudalei",
          prop: "categories",
          type: "slot",
        },
        {
          label: "danjuxiaoleibianma",
          prop: "smallCode",
        },
        {
          label: "danjuxiaoleimingcheng",
          prop: "smallName",
        },
        {
          label: "chuangjianren",
          prop: "createByObject.nickname",
        },
        {
          label: "chuangjianshijian",
          type: "time",
          prop: "createTime",
        },
        {
          label: "caozuo",
          type: "slot",
          width: 150,
          fixed: "right",
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      // this.yt.SELECT_URL = "/web/system/auth/user/listByIds";
      // this.yt.SELECT_RESULT_KEY = "data";
      // this.yt.SELECT_ID = "id";
      // this.yt.SELECT_TITLE = "nickname";
      this.yt.get(1);
    }, 300);
  },

  methods: {},
};
</script>
